export enum Sports {
    Soccer,
    Rugby,
    Gaa,
    Hockey
}
